import { useSignal } from "@preact/signals-react";
import { ErrorField } from "../../../../types/ErrorField";
import TextEdit from "../../../molecules/TextEdit";
import SelectTextField, { OptionProps } from "../../../molecules/SelectTextField";
import { getErrorMessage } from "../../../../utils/formErrorUtils";

import MaskEdit from "../../../organisms/MaskEdit";


interface Props {
    form: any;
    errorFields: ErrorField[];
    changeForm: (field: string, value: string) => void;

    editForm?: boolean;
}


const IndividualFormTab1: React.FC<Props> = ({ form, errorFields, changeForm, editForm = false }) => {

    return (
        <div className="p-4 m-4">
            <div className="grid grid-cols-12 gap-4">
                <TextEdit
                    id="name"
                    label="Nome"
                    className="col-span-5"
                    value={form.name}
                    onChange={(e) => changeForm("name", e.target.value.toUpperCase())}
                    errorMessage={getErrorMessage(errorFields, "name")}
                />
                <MaskEdit
                    id="socialId"
                    label="CPF"
                    mask="___.___.___-__"
                    replacement={{ '_': /\d/ }}
                    className="col-span-2"
                    value={form.socialId}
                    disabled={editForm}
                    onChange={(e) => changeForm("socialId", e.target.value)}
                    errorMessage={getErrorMessage(errorFields, "social_id")}
                />

                <TextEdit
                    id="email"
                    label="Email"
                    className="col-span-5"
                    value={form.email}
                    onChange={(e) => changeForm("email", e.target.value.toUpperCase())}
                    errorMessage={getErrorMessage(errorFields, "email")}
                />
            </div>

            <div className="grid grid-cols-12 gap-4 mt-6">
                <SelectTextField
                    id="isNationalNumber"
                    name='isNationalNumber'
                    label=""
                    value={form.isNationalNumber}
                    items={[{ "value": "1", "label": "Brasil" }, { "value": "2", "label": "Estrangeiro" }]}
                    className="col-span-3"
                    onChange={(e) => changeForm("isNationalNumber", e.target.value)}
                    errorMessage={getErrorMessage(errorFields, "isNationalNumber")}
                />
                <MaskEdit
                    id="mobilePhone"
                    label="Celular"
                    mask={form.isNationalNumber == 1 ? "(__)_____-____" : "___________________________"}
                    replacement={{ '_': /\d/ }}
                    className="col-span-2"
                    value={form.mobilePhone}
                    onChange={(e) => changeForm("mobilePhone", e.target.value)}
                    errorMessage={getErrorMessage(errorFields, "mobilePhone")}
                />
                <MaskEdit
                    id="phone"
                    label="Fixo"
                    mask="(__)____-____"
                    replacement={{ '_': /\d/ }}
                    className="col-span-2"
                    value={form.phone}
                    onChange={(e) => changeForm("phone", e.target.value)}
                    errorMessage={getErrorMessage(errorFields, "phone")}
                />
            </div>
        </div>
    );
};

export default IndividualFormTab1;
